import formInitialValues from '../pages/stepper4/components/EmploymentPage/FormModel/formInitialValues';

const initialState = {
  ...formInitialValues,
  // counter: 0,
};

const addOrReplace = (state, payload) => {
  const val = state.filter((el) => el.docType != payload.docType); //ลบของเดิม
  val.push(payload); //เพิ่ม
  return val;
};

const clear = (state) => {
  const val = state.map((obj) => {
    const newObj = {...obj};
    newObj.name = '';
    newObj.url = '';
    return newObj;
  })
  return val;
};

const counterReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INCREMENT':
      return {
        ...state,
        counter: {
          ...state.counter,
          cnt: state.counter.cnt + 1,
        },
        // return { ...state, counter: state.counter.cnt + 1 };
      };
    case 'DECREMENT':
      return { ...state, counter: state.counter.cnt - 1 };
    case 'SET_FORM_DATA':
      return {
        ...state,
        // lastName: action.payload.lastName,
      };
    case 'SET_FILE1_DATA':
      return {
        ...state,
        counter: { file1Data: action.payload },
      };
    case 'SET_FILE2_DATA':
      return {
        ...state,
        counter: { file2Data: action.payload },
      };
    case 'SET_FILE_DATA':
      return {
        ...state,
        // counter: { fileData: [...state.counter.fileData, action.payload] },
        counter: {
          ...state.counter,
          fileData: addOrReplace(state.counter.fileData, action.payload),
        },
      };
    case 'CLEAR_FILE_DATA':
        return {
          ...state,
          counter: {
            ...state.counter,
            fileData: clear(state.counter.fileData),
          },
        };    
    case 'SET_HAS_WORK_EXPERIENCE':
      return {
        ...state,
        counter: {
          ...state.counter,
          hasWorkExperienceRdx: action.payload,
        },
      };
    default:
      return state;
  }
};

export default counterReducer;
